<template>
  <div>
    <md-card class="md-primary">
      <md-card-header>
        <md-card-header-text>
          <md-card-content>Einreichungs-Bestätungs-Code</md-card-content>
          <div class="md-title">{{ code }}</div>
          <br />
          <md-card-content
            ><md-icon>info</md-icon> Bitte diesen Code kopieren oder
            aufschreiben.</md-card-content
          >
        </md-card-header-text>
      </md-card-header>
    </md-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    code: String
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {}
};
</script>
<style lang="sass"></style>
